import { alpha } from '@mui/material/styles'

import { colors } from './colors'

export type DatasetColors = {
  color: string
  color0: string
  color1: string
}

export type Charts = {
  fontSize: number
  axis: {
    labelColor: string
  }
  tooltip: {
    backgroundColor: string
    textColor: string
  }
  dataset: {
    networth: DatasetColors
    income: DatasetColors
    taxes: DatasetColors
    expenses: DatasetColors
    contributions: DatasetColors
  }
}

const buildDatasetColors = (color: string): DatasetColors => ({
  color,
  color0: alpha(color, 0.1),
  color1: alpha(color, 0.04),
})

export const charts: Charts = {
  fontSize: 10,
  axis: {
    labelColor: colors.blueGrey[300],
  },
  tooltip: {
    backgroundColor: alpha(colors.common.black, 0.54),
    textColor: colors.common.white,
  },
  dataset: {
    networth: buildDatasetColors(colors.brandGreen[500]),
    income: buildDatasetColors(colors.deepPurple.A700),
    taxes: buildDatasetColors(colors.indigo.A100),
    expenses: buildDatasetColors(colors.red[200]),
    contributions: buildDatasetColors(colors.orange[300]),
  },
}
